export default __webpack_public_path__ + "static/media/prenatalLandingPageHowItWorksStep3.b8daf2a0.png";